import { Button } from "antd";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";
import { SideBarItemProps } from "types/route";
import { SIDEBAR_ITEM } from "./sidebar/sidebar";

const SidebarRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (route: SideBarItemProps, idx: number) => {
    navigate(route.path);
  };

  return (
    <div className="flex flex-col px-1">
      {SIDEBAR_ITEM?.map((route, idx) => (
        <Button
          key={idx}
          onClick={() => handleNav(route, idx)}
          className={clsx("btn app-dashboard-sidebar-nav flex items-center", {
            active: location.pathname.startsWith(route.parent),
          })}
        >
          <img src={route.icon} alt="" width={18} height={18} className="flex-shrink-0" />
          <p className="ml-2 text-[15px]">{route.title}</p>
        </Button>
      ))}
    </div>
  );
};

export default SidebarRouter;
